import React, { useEffect, useState, useRef } from "react";
import {
  menu,
  close,
  colorLogo,
  colorLogoWhite,
  whiteLogo,
} from "../../assets";
import { Link, useLocation } from "react-router-dom";
import {
  ArrowRight,
  Briefcase,
  CircleUser,
  PhoneForwarded,
} from "lucide-react";
import NetworksDropdown from "./NetworksDropdown";
import AboutUsDropdown from "./AboutUsDropdown";
import OurExpertiseDropdown from "./OurExpertiseDropdown";
import { HoverBorderGradient } from "../ui/hover-border-gradient";
import { useCallback } from "react";
import horizontalLogo from "../../assets/horizontal-logo2.png";
import {
  Home,
  Info,
  Target,
  Lightbulb,
  Users,
  Handshake,
  BriefcaseBusiness,
  Building2,
  FileSpreadsheet,
  Phone,
} from "lucide-react";

// Navigation links array
const navLinks = [
  { path: "/", title: "Home" },
  // { path: "/home2", title: "Home2" },
  // { path: "/aboutus", title: "About Us" },
  // { path: "/services", title: "Services" },
  // { path: "/contactNew", title: "Contact" },
];

const Header = () => {
  const [active, setActive] = useState("Home");
  const [toggle, setToggle] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const sidebarRef = useRef();

  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();

  let lastScrollY = 0;

  // Close sidebar with animation
  const closeSidebar = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      setToggle(false);
      setIsClosing(false);
    }, 300); // transition duration in ms
  }, []);

  //click outside toggling sidenav

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        toggle &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        closeSidebar();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [toggle, closeSidebar]);

  // header animation scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      const isMobile = window.innerWidth < 768; // adjust breakpoint if needed

      // if (isMobile) {
      //   // On mobile, do nothing — prevent scroll changes
      //   return;
      // }

      if (currentScrollY > lastScrollY) {
        setHidden(true);
      } else {
        setHidden(false);
      }

      setScrolled(currentScrollY > 50);

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        // variants={{
        //   visible: { y: 0 },
        //   hidden: { y: "-130%" },
        // }}
        // animate={hidden ? "hidden" : "visible"}
        // transition={{ duration: 0.35, ease: "easeInOut" }}
        // className="fixed top-0 left-0 w-full z-50 md:px-12 "
        className={`fixed top-0 left-0 w-full z-30 transition-all md:px-6 xl:px-12
        ${
          scrolled
            ? "backdrop-blur-md shadow-md z-30 bg-black border-b border-b-white/10"
            : "bg-transparent border-b border-b-transparent"
        }`}
        // variants={{
        //   visible: { y: 0 },
        //   hidden: { y: "-130%" },
        // }}
        // animate={hidden ? "hidden" : "visible"}
        // transition={{ duration: 0.35, ease: "easeInOut" }}
        // className="sticky top-0 backdrop-blur-sm border-b border-b-white/10 z-20"
      >
        <div className={`${scrolled ? "py-2" : "py-2"}`}>
          <div className="container">
            <div className="flex justify-between items-center">
              <Link to="/">
                {/* Logo */}
                <img
                  src={`${scrolled ? colorLogoWhite : colorLogoWhite}`}
                  alt="Main Logo"
                  // height={120}
                  // width={120}
                  className="cursor-pointer w-[70px]  lg:w-[120px] lg:h-[120px]"
                />
              </Link>

              {/* Desktop Navigation */}
              <nav className="hidden lg:flex gap-6 text-white/80 items-center">
                {navLinks.map((nav, index) => {
                  const isActive = location.pathname === nav.path;

                  return (
                    <div key={nav.path} className="flex items-center gap-2">
                      <Link
                        to={nav.path}
                        className={`transition-transform duration-300 navlink-styles relative  ease-in-out hover:scale-105 ${
                          window.location.pathname === nav.path
                            ? "text-gold font-semibold underline underline-offset-4"
                            : "text-white font-semibold"
                        } ${isActive ? "font-semibold text-gold" : ""}`}
                      >
                        {nav.title}
                      </Link>
                    </div>
                  );
                })}
                <AboutUsDropdown isMobile={false} />

                <OurExpertiseDropdown isMobile={false} />

                <Link
                  // to="https://www.scanglobalsolutions.ae/"
                  to="/solutions"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="navlink-styles !font-medium py-1 flex gap-1 items-center"
                >
                  <img
                    src="/images/solutions/mini-logo.png"
                    className="w-7 h-7 object-cover"
                  />
                  Advisory
                </Link>
                <Link
                  // to="https://www.scanglobalrealty.com/"
                  to="/realty"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="navlink-styles !font-medium py-1 flex gap-1 items-center"
                >
                  <img
                    src="/images/realty/realty-logo.png"
                    className="w-6 h-6 object-cover"
                  />
                  Realty
                </Link>
                <Link
                  // to="https://www.scanglobalrealty.com/"
                  to="/careers"
                  // target="_blank"
                  rel="noopener noreferrer"
                  className="navlink-styles !font-medium py-1 flex gap-1 items-center"
                >
                  Careers
                </Link>

                {/* <Link
                    
                    to="/contact"
                    // target="_blank"
                    rel="noopener noreferrer"
                    className="navlink-styles py-1"
                  >
                    Contact Us
                  </Link> */}

                {/* <Link
                    to="/contact"
                    className="flex justify-center gap-2 items-center mx-auto shadow-xl text-base bg-gradient text-slate-900 backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-gold hover:text-slate-900 hover:border-gold before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 ps-4 pe-1 py-1 overflow-hidden border-2 rounded-full group"
                  >
                    Contact Us
                    <svg
                      className="w-7 h-7 justify-end group-hover:rotate-90 group-hover:bg-gray-50 ease-linear duration-300  bg-black text-white p-2 rounded-full group-hover:border-none rotate-45"
                      viewBox="0 0 16 19"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                        className="fill-white group-hover:fill-gray-800"
                      />
                    </svg>
                  </Link> */}

                {/* <div className="contact-btn-wrapper">
                    <button className="contact-btn">
                      <CircleUser size={20} />
                      Contact Us
                    </button>
                  </div> */}
                <Link to="/contact">
                  <HoverBorderGradient
                    containerClassName="rounded-full"
                    as="button"
                    className="group bg-white/5 backdrop-blur-md text-white font-semibold py-1.5 ps-5 pe-1.5 rounded-full hover:opacity-80 transition duration-200 inline-flex items-center gap-2 leading-normal"
                  >
                    Contact Us
                    <span className="bg-white text-slate-900 p-2 rounded-full transition-transform duration-300 group-hover:rotate-[45deg]">
                      <PhoneForwarded size={18} />
                    </span>
                  </HoverBorderGradient>
                </Link>
              </nav>

              {/* Mobile Navigation Toggle */}
              <div className="lg:hidden flex flex-1 justify-end items-center">
                <img
                  src={toggle ? close : menu}
                  alt="menu"
                  className={`w-[25px] h-[25px] object-contain ${
                    scrolled ? "" : ""
                  } cursor-pointer`}
                  onClick={() => setToggle(true)}
                />

                {/* Mobile Navigation */}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Navigation Overlay */}
      {toggle && (
        <div
          className={`fixed inset-0 z-[52] bg-black/50 backdrop-blur-sm transition-opacity duration-300 ${
            isClosing ? "opacity-0" : "opacity-100"
          }`}
        >
          {/* sidebar */}
          <div
            // className="lg:hidden fixed top-0 right-0 h-full w-[250px] bg-black-gradient px-6 py-5 shadow-lg transition-transform transform translate-x-0 duration-300 flex flex-col items-start"
            ref={sidebarRef}
            className={`absolute border-l-white/5 border-l top-0 right-0 h-full w-[250px] bg-slate-900 px-6 py-5 shadow-lg transform transition-transform duration-300 ${
              isClosing ? "translate-x-full" : "translate-x-0"
            }`}
            style={{ zIndex: 1000 }}
          >
            <Link to="/" className="flex justify-start">
              {/* Logo */}
              <img
                src={horizontalLogo}
                alt="Main Logo"
                className="cursor-pointer w-[200px]  "
              />
            </Link>
            {/* <img
                      src={toggle ? close : menu}
                      alt="menu"
                      className={`w-[25px] h-[25px] object-contain ${
                        scrolled ? "" : ""
                      } cursor-pointer`}
                      onClick={() => setToggle(!toggle)}
                    /> */}
            <ul className="list-none flex flex-col gap-y-4 mt-7 items-start">
              {navLinks.map((nav, index) => (
                <li
                  key={nav.path}
                  className={` cursor-pointer text-[16px] ${
                    active === nav.title
                      ? "text-white navlink-styles"
                      : "text-gray-200"
                  }`}
                  onClick={() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    setActive(nav.title);
                    closeSidebar();
                  }}
                >
                  <Link to={nav.path} className="flex items-center gap-4">
                    {" "}
                    <Home size={20} className="navlink-icon" />
                    {nav.title}
                  </Link>
                </li>
              ))}

              <li>
                <AboutUsDropdown setToggle={setToggle} isMobile={true} />
              </li>
              <li>
                <OurExpertiseDropdown setToggle={setToggle} isMobile={true} />
              </li>

              {/* <li
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: "smooth" });
                          setToggle(false);
                        }}
                      >
                        <Link
                          to="/solutions"
                          className="navlink-styles py-1 flex gap-1 items-center"
                        >
                          <img
                            src="/images/solutions/mini-logo.png"
                            className="w-7 h-7 object-cover"
                          />
                          Advisory
                        </Link>
                      </li>

                      <li
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: "smooth" });
                          setToggle(false);
                        }}
                      >
                        <Link
                          to="/realty"
                          className="navlink-styles py-1 flex gap-1 items-center"
                        >
                          <img
                            src="/images/realty/realty-logo.png"
                            className="w-7 h-7 object-cover"
                          />
                          Realty
                        </Link>
                      </li> */}
              <li
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  closeSidebar();
                }}
              >
                <Link to="/careers" className="navlink-styles flex gap-4">
                  {" "}
                  <Briefcase size={20} className="navlink-icon" />
                  Careers{" "}
                </Link>
              </li>

              <li
                onClick={() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                  closeSidebar();
                }}
              >
                <Link to="/contact" className="navlink-styles flex gap-4">
                  {" "}
                  <Phone size={20} className="navlink-icon" />
                  Contact Us{" "}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
